import React, { useState } from 'react';
import classNames from 'classnames';
import Loader from 'src/components/Loader';
import styles from './assets/invoice-create-screen.module.scss';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/InvoiceForm';

export interface StateProps {
    inProgress: boolean;
}

export interface DispatchProps {}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const InvoiceCreateScreen: React.FunctionComponent<Props> = (props) => {
    const [files, setFiles] = useState([]);

    if (props.inProgress) {
        return <Loader />;
    }
    return (
        <RoleLayout>
            <div>
                <h2>INVOICE {`>`} ADD NEW</h2>
            </div>
            <div className={classNames(styles.wrapForm)}>
                <Form
                    files={files}
                    setFiles={setFiles}
                    removeFile={(id) => {
                        files.splice(id, 1);
                        setFiles([...files]);
                    }}
                    initialValues={{}}
                />
            </div>
        </RoleLayout>
    );
};

export default InvoiceCreateScreen;
